import React from 'react';
import {
  HiOutlineChartBar,
  HiOutlineOfficeBuilding,
  HiOutlineUserGroup,
  HiOutlineArrowLeft,
  HiOutlineLogout,
  HiOutlineViewGrid
} from 'react-icons/hi';
import { TbBuildingFactory2 } from 'react-icons/tb';

function Header({ user, onLogout, currentPage, setCurrentPage, selectedZone, setSelectedZone }) {
  return (
    <div className="header">
      <div className="header-logo">
        <svg className="cloud-icon" viewBox="0 0 100 60" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="cloudGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{stopColor:'#dc2626',stopOpacity:1}} />
              <stop offset="100%" style={{stopColor:'#ff4444',stopOpacity:1}} />
            </linearGradient>
          </defs>
          <path d="M 20,45 Q 10,45 10,35 Q 10,25 20,25 Q 20,15 30,15 Q 40,15 40,25 Q 50,10 65,10 Q 80,10 80,25 Q 90,25 90,35 Q 90,45 80,45 Z"
                fill="url(#cloudGradient)" opacity="0.9"/>
        </svg>
        <div>
          <h1><span className="mim">MiM</span><span className="bytes">Bytes</span></h1>
          <div className="header-subtitle">IoT Cloud Control</div>
        </div>
      </div>

      <div className="header-nav">
        {selectedZone ? (
          <button
            className="nav-btn active"
            onClick={() => setSelectedZone(null)}
          >
            <HiOutlineArrowLeft style={{marginRight: '6px', fontSize: '18px'}} />
            Geri Dön
          </button>
        ) : (
          <>
            <button
              className={`nav-btn ${currentPage === 'dashboard' ? 'active' : ''}`}
              onClick={() => setCurrentPage('dashboard')}
            >
              <HiOutlineChartBar style={{marginRight: '6px', fontSize: '18px'}} />
              Dashboard
            </button>

            {user?.role === 'admin' && (
              <>
                <button
                  className={`nav-btn ${currentPage === 'facilities' ? 'active' : ''}`}
                  onClick={() => setCurrentPage('facilities')}
                >
                  <TbBuildingFactory2 style={{marginRight: '6px', fontSize: '18px'}} />
                  Tesisler
                </button>
                <button
                  className={`nav-btn ${currentPage === 'zones' ? 'active' : ''}`}
                  onClick={() => setCurrentPage('zones')}
                >
                  <HiOutlineViewGrid style={{marginRight: '6px', fontSize: '18px'}} />
                  Bölümler
                </button>
                <button
                  className={`nav-btn ${currentPage === 'users' ? 'active' : ''}`}
                  onClick={() => setCurrentPage('users')}
                >
                  <HiOutlineUserGroup style={{marginRight: '6px', fontSize: '18px'}} />
                  Kullanıcılar
                </button>
              </>
            )}
          </>
        )}
      </div>

      <div className="header-right">
        <span>{user?.username}</span>
        <button onClick={onLogout} className="btn-logout">
          <HiOutlineLogout style={{marginRight: '4px'}} />
          Çıkış
        </button>
      </div>
    </div>
  );
}

export default Header;
